import { useState, useContext, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/Success.css';
import { AppContext } from "../../Context";

import { IoCheckmark, IoCloseOutline } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";



export default function Success({data}) {

    const { t } = useTranslation();
    const active = useRef(true);
    const {successData} = useContext(AppContext);
    const [success, setsuccess] = successData;

    const navigate = useNavigate();
    
    const [title, settitle] = useState(data?.error ? t("ops") : t("wow"));
    const [short, setshort] = useState(t("success_text"));
    const [error, seterror] = useState(false);
    

    useEffect(() => {

        if (active.current)  {
            
            active.current = false;
            if (data?.title) {
                settitle(data?.title);
            }
            if (data?.short) {
                setshort(data?.short);
            }
            
            if (data?.error) {
                seterror(true);
            }
            
            setTimeout(() => {
                if (data?.redirect) {
                    navigate(data?.redirect);
                }

                if (data?.short == "login") {
                    window.location.reload();
                }
                
                setsuccess(false);
                
            }, 2500);
        }
    }, []);


    return (
        <div className='successWhite'>
            <div className={error ? 'successBox error' : 'successBox'}>
                <p>
                    <b><FaCheck /></b>
                </p>
                <div className='text'>
                    <h3>{title}</h3>
                    <span>{short == "login" ? t("logout_text") : short}</span>
                </div>

                <a onClick={() => setsuccess(false)}><IoCloseOutline size={20} /></a>

                
            </div>

        </div>
    )
}
